export default "__VITE_ASSET__MT4KmqDz__"